import Card from 'react-bootstrap/Card';
import logofoot from '../assets/Images/logo-foot.png';
import React from 'react';
import phone from "../assets/Images/Group 2390.png";
import location from "../assets/Images/Group 2389.png";
import emailImage from "../assets/Images/Group 2391.png"
import { useState } from "react";
import {useLocation} from "react-router-dom";


function PartnerCard(props) {
    const locate = useLocation();
  const { pathname } = locate;
  const [desc, setDesc] = useState(false);
  function appearContent() {
    setDesc(true);
  } function dappearContent() {
    setDesc(false);
  }
  const handleClick = () => {
    // Redirect to another page
    window.location.href = props.to;
  };

  const cardClassName = 'rounded-2  border-0 ';
  const cardNameClassName = props.CardName ? `card-name-${props.CardName.toLowerCase().replace(/\s/g, '-')}` : '';

  const combinedClassName = `${cardClassName}  ${cardNameClassName} ${props.className}`;


  return (
    // , rgb(51 51 51 / 64%) 0px -90px 30px -20px inset
    <Card onClick={handleClick} onMouseOver={appearContent} onMouseOut={dappearContent} style={{
      color: 'black', width: '20rem',
      height:pathname!='/tech-partners'? 'fit-content':'15rem',
      boxShadow: desc ? '0 3px 15px  rgba(0, 0, 0, 0.5)' : '0 3px 15px  rgba(0, 0, 0, 0.2)',
      transition:'all 0.3s ease',cursor:'pointer'

    }} className={combinedClassName} >
      {/*<Card.Header className={'bg-transparent justify-content-center border-0 relative '}>*/}
      {/*</Card.Header>*/}
      <Card.Body className="" style={{ marginTop: desc ? '-10px' : null, transition: 'all  0.3s ease' }} >
        <img src={props.image} className={pathname!='/tech-partners'?"mb-2 mt-3":"mt-3"} width={'250px'}  />

          {pathname!='/tech-partners'?<center><h5 className='bebas line-normal h2 mt-3'>{props.Title}</h5 ></center>:null}
        {/*<Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>*/}

          {pathname!='/tech-partners'? <Card.Text style={{color:'#000000A1'}} className={'mt-4 fs-7'}>
              <div className={'mt-3'}>
                 <img src={location}/>
                    <span className={'mx-2'}>{props.address}</span>
              </div>
             <div className={'mt-2'}>
                  <a href={props.href}><img src={emailImage}/></a>
                 <span className={'mx-2'}>{props.email}</span>
              </div>
             <div className={'mt-2'}>
                 <img src={phone}/>
                 <span className={'mx-2'}>{props.phone}</span>
             </div>
         </Card.Text>:null}

      </Card.Body>
    </Card>
  );
}

export default PartnerCard;